import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

/**
 * URL filter params for the active vehicle usages table.
 * `overdue` is stored as the string "true" when enabled so it round-trips
 * cleanly through the URL (no boolean coercion pitfalls).
 */
export const activeVehicleUsageFilterSchema = z.object({
	search: optionalFilterString,
	overdue: optionalFilterString,
});

export type ActiveVehicleUsageFilters = z.infer<
	typeof activeVehicleUsageFilterSchema
>;
